"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReleaseDrippingTypes = exports.ClassTypes = exports.DrippingLiberationTypes = exports.BulkWizardActions = void 0;
var BulkWizardActions;
(function (BulkWizardActions) {
    BulkWizardActions[BulkWizardActions["New"] = 1] = "New";
    BulkWizardActions[BulkWizardActions["Delete"] = 2] = "Delete";
})(BulkWizardActions || (exports.BulkWizardActions = BulkWizardActions = {}));
var DrippingLiberationTypes;
(function (DrippingLiberationTypes) {
    DrippingLiberationTypes["Date"] = "BY_DATE";
    DrippingLiberationTypes["Days"] = "BY_DAYS";
    DrippingLiberationTypes["Quiz"] = "BY_QUIZ";
})(DrippingLiberationTypes || (exports.DrippingLiberationTypes = DrippingLiberationTypes = {}));
var ClassTypes;
(function (ClassTypes) {
    ClassTypes[ClassTypes["All"] = 1] = "All";
    ClassTypes[ClassTypes["Specific"] = 2] = "Specific";
})(ClassTypes || (exports.ClassTypes = ClassTypes = {}));
var ReleaseDrippingTypes;
(function (ReleaseDrippingTypes) {
    ReleaseDrippingTypes[ReleaseDrippingTypes["None"] = 0] = "None";
    ReleaseDrippingTypes[ReleaseDrippingTypes["DaysAfter"] = 1] = "DaysAfter";
    ReleaseDrippingTypes[ReleaseDrippingTypes["SpecificDate"] = 2] = "SpecificDate";
    ReleaseDrippingTypes[ReleaseDrippingTypes["Quiz"] = 3] = "Quiz";
})(ReleaseDrippingTypes || (exports.ReleaseDrippingTypes = ReleaseDrippingTypes = {}));
